import { defineMessages } from "react-intl"

export const customerFeedbackMessages = defineMessages({
	empty: {
		defaultMessage: "No feedback has been given for this listing yet",
		id: "vehicleDetails.customerFeedback.empty",
	},
	feedback: {
		defaultMessage: "View customer feedback ({count})",
		id: "vehicleDetails.customerFeedback.feedback",
	},
	headerNoFeedback: {
		defaultMessage: "No customer feedback yet",
		id: "vehicleDetails.customerFeedback.headerNoFeedback",
	},
	headline: {
		defaultMessage: "Customer Feedback",
		id: "vehicleDetails.customerFeedback.headline",
	},
	info: {
		defaultMessage:
			"Users of the customer application can comment on this listing; the feedback is only visible in the dealer application. Some customer feedback may not directly pertain to the quality of the listing.",
		id: "vehicleDetails.customerFeedback.info",
	},
	neitherSatisfiedNorDissatisfied: {
		defaultMessage: "Neither satisfied nor dissatisfied",
		id: "vehicleDetails.customerFeedback.neitherSatisfiedNorDissatisfied",
	},
	showAllFeedbackButton: {
		defaultMessage: "View all customer feedback ({count})",
		id: "vehicleDetails.customerFeedback.showAllFeedback",
	},
	showEnglishTextButton: {
		defaultMessage: "Translate feedback to English",
		id: "vehicleDetails.customerFeedback.showEnglishText",
	},
	showOriginalLanguageTextButton: {
		defaultMessage: "Show original",
		id: "vehicleDetails.customerFeedback.showOriginalLanguageText",
	},
	somewhatDissatisfied: {
		defaultMessage: "Somewhat dissatisfied",
		id: "vehicleDetails.customerFeedback.somewhatDissatisfied",
	},
	somewhatSatisfied: {
		defaultMessage: "Somewhat satisfied",
		id: "vehicleDetails.customerFeedback.somewhatSatisfied",
	},
	veryDissatisfied: {
		defaultMessage: "Very dissatisfied",
		id: "vehicleDetails.customerFeedback.veryDissatisfied",
	},
	verySatisfied: {
		defaultMessage: "Very satisfied",
		id: "vehicleDetails.customerFeedback.verySatisfied",
	},
})
